import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Btn } from "@/components/Btn";
import { CTA } from "@/lib/brand";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  { q: "What kind of junk do you haul?", a: "Almost anything that is not hazardous! Furniture, mattresses, appliances, hot tubs, garage and estate cleanouts, yard debris, remodel debris and more. If it is in the way, we will get it out." },
  { q: "How fast can you come out?", a: "Fast is our whole thing! We offer same day and next day pickups across the Lowcountry whenever our schedule allows. Text us and we will find you a window." },
  { q: "What areas do you serve?", a: "Charleston, Berkeley and Dorchester counties, from downtown Charleston out to Summerville, Moncks Corner, the islands and everywhere between. Check our Service Areas page for your town." },
  { q: "How does pricing work?", a: "Every job is priced upfront based on how much space your stuff takes up in our truck. You always hear the price before we start, and there are no surprise fees." },
  { q: "Do you offer free quotes?", a: "Yes! Quotes are always free with zero pressure. Tap Get My Free Quote or text us a photo of what needs to go." },
  { q: "Is there anything you cannot take?", a: "A short list of hazardous items like chemicals, propane, ammo, asbestos, medical waste and liquids. See our What We Cannot Haul page for the friendly rundown." },
  { q: "Do you handle heavy material?", a: "We sure do. Concrete, tile, brick and dirt are all handled by our heavy material hauling service." },
  { q: "Do you donate or recycle?", a: "Whenever we can! Usable items and recyclable materials get a second life instead of heading straight to the landfill." },
  { q: "Do I need to be home?", a: "Not always. As long as we can safely reach the items and you have approved the plan, we can often haul while you are out. Just chat with us when we schedule." },
  { q: "What payment methods do you accept?", a: "We keep it easy! We take cash, Zelle, Venmo, Cash App and check. We will confirm the details when we set up your pickup." },
  { q: "How do I book?", a: "Call or text 843-518-0021, or fill out the quick quote form. We will confirm your price and arrival window and then make it skedaddle." },
];

export default function Faq() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
  };
  return (
    <>
      <Seo path="/faq" title="FAQ" description="Answers to common questions about Skedaddle Junk Removal. Pricing, service areas, what we haul and how fast we can get to you." jsonLd={jsonLd} />
      <PageHero eyebrow="FAQ" title="Answers before you ask." subtitle="Got a question about hauling your junk away? We probably answered it right here!" />
      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-4 md:px-8">
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="bg-cream border-2 border-charcoal rounded-2xl px-5 shadow-brut">
                <AccordionTrigger className="font-heading font-bold text-lg text-left hover:no-underline">{f.q}</AccordionTrigger>
                <AccordionContent className="font-body text-charcoal/75 text-base">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <div className="mt-12 text-center"><Btn to="/contact" variant="primary">{CTA.quote}</Btn></div>
        </div>
      </section>
    </>
  );
}
